import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { SUPPLIER_ACTIVATION_EARLIEST_DATE } from 'components/reports/Metrics/constants/SupplierActivation'
import { SupplierActivationInputDtoInput } from 'generated/graphql'
import { resolveSupplierActivationPeriod } from 'helpers/metricsPeriod.helpers'

import { SupplierActivationFilterValues } from './SupplierActivationFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: SupplierActivationInputDtoInput
}

export const useSupplierActivationQueryInput = (): QueryInput => {
  const { control } = useFormContext<SupplierActivationFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === 'custom'

  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolveSupplierActivationPeriod(period)

  const start = rawStart ? maxDate([rawStart, SUPPLIER_ACTIVATION_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      vehicleType,
    },
  }
}
